module.exports = __webpack_public_path__ + "static/media/bookmark.009c33c4.svg";